import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const ToolBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  padding-bottom: 18px;
  margin-bottom: 30px;
  border-bottom: 1px solid ${Color.greySeparator};
  position: relative;

  ${breakpoints.phone} {
    margin-bottom: -1px;
    border-bottom: none;
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
    }
  }
  .tool {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    width: 145px;
    padding: 0 20px;
    position: relative;
    cursor: pointer;

    &:first-of-type {
      padding-left: 0;
    }

    ${breakpoints.phone} {
      padding: 0 8px;
      width: calc(100% / 4 + 4px);
    }
    &.qualification,
    &.print,
    &.save {
      border-right: 1px solid ${Color.greySeparator};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          border-right: 1px solid ${ColorDark.greySeparator};
        }
      }
    }
    span {
      font-size: 11px;
      line-height: 25px;
      color: ${Color.grey};
      ${Font.sansRegular}
      margin-bottom: 5px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    &.qualification span,
    &.print span,
    &.save span {
      text-transform: uppercase;
    }

    :not(.save) {
      :hover {
        opacity: 0.8;
      }
      svg {
        fill: ${Color.grey};
        color: ${Color.grey};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            fill: ${ColorDark.textLight};
            color: ${ColorDark.textLight};
          }
        }
      }
    }
  }
  .tool .p-4 {
    padding-top: 13px;
  }
  .tool button,
  .tool h2 {
    ${Font.sansRegular}
    text-transform: uppercase;
    font-size: 11px;
    line-height: 25px;
    color: ${Color.grey};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }

  .text-razor-selected svg {
    fill: ${Color.mainColor} !important;
    stroke: ${Color.mainColor} !important;
  }
  .tool .toast-container {
    box-shadow: none;
    ${breakpoints.phone} {
      left: auto;
      right: 50%;
    }
  }
  .tool .toast-container div.mb-4 {
    margin-top: 5px;
  }
  .tool .toast-container > button {
    position: absolute;
    top: 0;
    right: -30px;
    width: 32px;
    height: 32px;
    background-color: ${Color.greyF5F5F5};
    font-size: 20px;
    ${Font.sansLight}
    z-index: 3;
    z-index: 999999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tool .toast-container .star-text-button {
    font-size: 14px;
    ${Font.sansSemiBold}
    margin-bottom: 25px;
    margin-top: 15px;
    color: ${Color.white};
  }
  .tool .card-toast {
    z-index: 99999;
    position: inherit;
    box-shadow: none;
    padding: 0;
  }
  #score span {
    font-size: 15px !important;
    line-height: 15px !important;
    //text-transform: lowercase;
    color: ${Color.grey999};
  }
  .tool .card-toast svg {
    fill: ${Color.white} !important;
    stroke: ${Color.grey} !important;
    stroke-width: 1px !important;
    width: 38px;
    height: 38px;
  }
  .tool .toast-container .mt-2 svg {
    fill: ${Color.grey999} !important;
    stroke: ${Color.grey999} !important;
    width: 11px;
    height: 11px;
    margin-right: 5px;
  }
  .tool .toast-container .star-text-selected {
    fill: ${Color.mainColor} !important;
    stroke: ${Color.mainColor} !important;
  }
  .tool .toast-container .star-text-puntuacion {
    margin-bottom: 15px;
  }

  .save {
    position: relative;

    .btn__collection--section {
      .isOpen {
        position: absolute;
        min-width: 300px;
        max-width: 300px;
        height: 480px;
        min-height: 480px;
        top: calc(100% - 2px);
        background-color: ${Color.greyF5F5F5};
        transform: none;
        ${breakpoints.tablet} {
          left: -150px;
        }
        ${breakpoints.phone} {
          top: 60px;
          left: -150px;
        }
      }
      .container-btn-group-collection button:last-of-type {
        color: ${Color.white};
      }
      .flip-container {
        transform: rotateY(0deg) !important;
        background-color: inherit;
        animation: none;
      }
      .btnCircle {
        color: ${Color.grey};
        margin-top: -4px;
        padding: 0;
        width: 120px;
        height: 30px;
        border-radius: 0;
        justify-content: flex-start;
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
        &:hover {
          opacity: 0.8;
          background-color: initial;
          //color: white;
        }
        &.save-open {
          svg {
            fill: ${Color.mainColor};
          }
        }
        .btn-deleted {
          ${breakpoints.darkMode} {
            [data-theme="dark"] & {
              svg {
                fill: ${ColorDark.textLight};
              }
            }
          }
        }
      }
    }
    &.save-open {
      span {
        color: ${Color.mainColor};
      }
    }
  }
  .score {
    span {
      font-size: 11px !important;
      line-height: 25px !important;
      ${Font.sansRegular};
    }
  }
  .score.open {
    span {
      color: ${Color.mainColor};
    }
    svg {
      fill: ${Color.mainColor}!important;
      color: ${Color.mainColor}!important;
    }
  }
  #scoringTool {
    display: none;
    position: absolute;
    top: 60px;
    left: 435px;
    ${breakpoints.tablet} {
      left: 335px;
    }
    ${breakpoints.phone} {
      top: 60px;
      left: 15%;
    }
  }
  ${breakpoints.mobileFirst} {
    #food-card-saved {
      transform: none;
    }
  }
  
      .btn-deleted {
        svg {
              fill: currentColor;
            }
      }

`;
export const StarList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 0.2rem;
  span.empty svg {
    fill: ${Color.greyE2E2E2};
  }
  span.active svg {
    fill: ${Color.grey};
  }
`;
